import { isPlaceholderEmail } from '@dosfilos/domain';

// ─── El correo en la cabecera de la ficha ───────────────────────────────────
// Un correo PROVISORIO (`@no-email.invalid`, el que deja una importación) no es
// de nadie: en su lugar se dice que no hay correo. `null` = mostrar «Sin correo
// registrado». Para todos los seminarios desde M4·D1 (antes, solo con
// `graduation_audit`); sin correos provisorios, nada cambia.

export function headerEmail(email: string): string | null {
  return isPlaceholderEmail(email) ? null : email;
}

/** «Apellido, Nombre» para las listas, sin la coma colgando cuando falta una
 *  parte (un docente importado puede no tener apellido): «, Juan» o «Pérez, »
 *  se veían como un error. Sin ninguna de las dos, una raya. */
export function listName(firstName: string | undefined, lastName: string | undefined): string {
  const parts = [lastName, firstName].map((p) => (p ?? '').trim()).filter(Boolean);
  return parts.length ? parts.join(', ') : '—';
}
